import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { api } from '../../../../services';
import { Spin } from 'antd';
import NoticeDetailType from './NoticeDetailType';
import { Map as MyMap } from '../../../../classes';
import NoticeMap from './NoticeMap';

import './NoticeDetail.css';
import AirButton from '../../../../common/components/AirButton';
import HereService from '../../../../services/Here';
import constants from '../../../../constants';

const API_KEY = constants.HERE_API_KEY;

@inject('translationsStore')
@observer
export default class NoticeDetail extends Component {
  constructor(props) {
    super(props);
    this.mapservice = new HereService(API_KEY);

    // this.defaultLatLng = { lat: '0.0', lng: '0.0'};
    this.defaultLatLng = { lat: '41.8901922', lng: '12.4921303' }; // colosseo
    this.defaultPosition = { ...this.defaultLatLng, available: false, place: '-' };

    this.MapRef = React.createRef();

    this.state = {
      loading: false,
      loadedHandle: null,

      loadingServiceAvailable: true,

      position: this.defaultPosition
    };
  }

  componentDidMount() {
    // this.MapInstance = this.MapRef.current.wrappedInstance;

    const { loading, loadedHandle, loadingServiceAvailable } = this.state;
    const { data = {} } = this.props;
    const handle = this.helperHandle(data);
    !loading && handle !== loadedHandle && loadingServiceAvailable && this.loadNoticeDetails();
    // this.setAsShown();
  }

  componentDidUpdate() {
    // this.MapInstance = this.MapRef.current && this.MapRef.current.wrappedInstance;

    const { loading, loadedHandle, loadingServiceAvailable } = this.state;
    const { data = {} } = this.props;
    const handle = this.helperHandle(data);
    !loading && handle !== loadedHandle && loadingServiceAvailable && this.loadNoticeDetails();
    // this.setAsShown();
  }

  handleReverseGeocodeSrv = async ({ lat, lng, mode = 'retrieveAddresses', notAvailable = '' }) => {
    let result = { lat, lng, available: false, place: notAvailable };
    try {
      let address = await this.mapservice.reverseGeocode(lat, lng, 0, mode);
      result = { ...result, available: true, place: address.label };
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(result);
    }
  };

  handleReverseGeocode = (mapInstance, { lat = 0, lng = 0, notAvailable = '' } = {}) => {
    return new Promise(resolve => {
      let result = { lat, lng, available: false, place: notAvailable };
      mapInstance
        .getAddressFromReverseGeocode({ lat, lng })
        .then(address => {
          result = { ...result, available: true, place: address.label };
        })
        .finally(() => {
          resolve(result);
        });
    });
  };

  helperHandle = data => {
    // return `notice-${data.date}`;
    return `notice.${data.asset}.${data.timestamp}`;
  };

  loadNoticeDetails = () => {
    this.setState({ loading: true });
    const { data = {}, onDetailShow } = this.props;
    if (data.position) {
      this.setState({ loadedHandle: this.helperHandle(data) });
      const positionLatLng = { lat: data.position.coordinates[1], lng: data.position.coordinates[0] };
      this.handleReverseGeocodeSrv({ ...positionLatLng, notAvailable: '-' }).then(position => {
        this.setState({ loading: false, position }, () => {
          typeof onDetailShow === 'function' && onDetailShow(data);
        });
      });
    } else {
      api('getDetailPositions', data.asset)
        .then(response => {
          const { positions } = response;
          return positions;
        })
        .then(positions => {
          const last = positions.sort((a, b) => (b.recorded_at_timestamp > a.recorded_at_timestamp ? 1 : -1)).shift();
          let positionLatLng = this.defaultLatLng;
          if (typeof last !== 'undefined') {
            positionLatLng = { lat: last.lat, lng: last.long };
            const cMap = new MyMap('dummyMap');
            this.handleReverseGeocode(cMap, { ...positionLatLng, notAvailablePosition: '-' }).then(position => {
              this.setState({ position });
            });
          } else {
            this.setState({ position: this.defaultPosition });
          }
          this.setState({ loadedHandle: this.helperHandle(data) });
        })
        .catch(err => {
          this.setState({ loadingServiceAvailable: false });
          console.error('Error loading notice details:', err);
        })
        .finally(() => {
          this.setState({ loading: false });
          typeof onDetailShow === 'function' && onDetailShow(data);
        });
    }
  };

  render() {
    const { translationsStore } = this.props;
    const { data = {} } = this.props;
    const {
      position,
      position: { place }
    } = this.state;

    return (
      <div className="NoticeDetail">
        <div className="DetailTipology">
          <div>
            <div>
              <div className="DetailLabel">{translationsStore.translate('notices.modalCarousel.labelTipology')}</div>
              <div className="DetailValue">
                <NoticeDetailType type={data.type} geofenceOptions={data.geofenceOptions} />
              </div>
            </div>
            <div>
              <div className="DetailLabel">{translationsStore.translate('notices.modalCarousel.labelPlate')}</div>
              <div className="DetailValue" style={{ textTransform: 'uppercase' }}>
                {data.plate}
              </div>
            </div>
            <div>
              <AirButton size="large" light={'true'} label={'Info'} onClick={this.props.onGoToDetail} />
            </div>
          </div>
          <div>
            <div>
              <div className="DetailLabel">{translationsStore.translate('notices.modalCarousel.labelCommonName')}</div>
              <div className="DetailValue">{data.name}</div>
            </div>
            <div>
              <div className="DetailLabel">{translationsStore.translate('notices.modalCarousel.labelDriverContacts')}</div>
              <div className="DetailValue">{data.mobile}</div>
            </div>
          </div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="DetailPosition">{place}</div>
          <div className="DetailMapWrapper">
            <NoticeMap data={data} position={position} />
          </div>
        </Spin>
        <div id="dummyMap" style={{ display: 'none' }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/NoticesLoader/NoticeDetail/NoticeDetail.js